<template>
  <InsurerPage :insurerSlug="$route.params.token">
    <template v-slot="{ insurer }">
      <v-app>
        <v-main>
          <v-container>
            <div class="text-center mb-3" style="width: 100%">
              <InsurerLogo :insurer="insurer" />
            </div>
            <v-row v-if="!found" dense>
              <v-col>
                <v-card
                  :disabled="loading"
                  style="max-width: 450px"
                  class="mx-auto pa-5"
                  outlined
                >
                  <v-card-title> Identificação do segurado </v-card-title>
                  <v-card-text>
                    Introduza um dos dados abaixo para localizar o seu contrato.

                    <br /><br />

                    <v-text-field
                      v-model="nif"
                      v-mask="'### ### ###'"
                      label="NIF"
                      placeholder="Ex.: 123 456 789"
                      hide-details="auto"
                      :color="insurer.color"
                      outlined
                      dense
                    ></v-text-field>
                    <div class="my-4">ou</div>
                    <v-text-field
                      v-model="policyNumber"
                      label="Número da apólice"
                      placeholder="Ex.: AP-000123456"
                      hide-details="auto"
                      :color="insurer.color"
                      outlined
                      dense
                    ></v-text-field>

                    <v-row v-if="notFound" class="mt-2">
                      <v-col>
                        <v-alert type="error" text border="left">
                          Contrato não encontrado
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-actions class="mt-2">
                    <v-btn
                      @click="search"
                      block
                      :color="insurer.color"
                      :dark="validated"
                      :disabled="!validated"
                      :loading="loading"
                    >
                      Consultar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <div
              v-else-if="foundContract && !rightInsured"
              style="max-width: 500px"
              class="mx-auto"
            >
              <v-row dense>
                <v-col>
                  <v-card flat>
                    <v-card-title>
                      Encontrámos os seguintes endereços:
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>

              <!-- SEGURADO -->
              <v-row dense>
                <v-col>
                  <v-card flat>
                    <v-card-title class="pb-1">
                      {{ foundContract.name }}
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>

              <v-row
                v-for="contract in contractsToDisplay"
                :key="contract.policyNumber"
                dense
              >
                <v-col>
                  <v-card outlined>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="subtitle-1">
                          {{ formatAddress(contract.address) }}
                        </v-list-item-title>

                        <v-list-item-subtitle class="text-caption grey--text">
                          Apólice {{ contract.policyNumber }} ·
                          {{ contract.type }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        :color="insurer.color"
                        dark
                        @click="handleClickRightInsured(contract)"
                      >
                        Selecionar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn @click="handleClickWrongInsured()" text small>
                    <v-icon left>mdi-arrow-left</v-icon>
                    Não encontrei meu contrato
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <div
              v-else-if="!foundContract && !rightInsured"
              class="text-center"
            >
              Nenhum contrato encontrado
              <br />
              <v-btn
                class="mt-5"
                outlined
                :color="insurer.color"
                @click="handleClickWrongInsured()"
              >
                Retornar
              </v-btn>
            </div>
            <div
              v-else-if="
                found && foundContract && rightInsured && !selectedContact
              "
              style="max-width: 400px"
              class="mx-auto"
            >
              <v-row dense>
                <v-col>
                  <v-card outlined>
                    <v-card-title> Selecione o contacto </v-card-title>
                    <v-card-text>
                      <div>Vamos enviar-lhe um código de acesso.</div>
                      <v-radio-group v-model="selectedContact">
                        <v-radio
                          v-if="!!foundContract.email"
                          value="email"
                          :label="'****' + foundContract['email'].slice(-5)"
                          :color="insurer.color"
                        >
                          {{ foundContract.email }}
                        </v-radio>
                        <v-radio
                          v-if="!!foundContract.contact1"
                          value="contact1"
                          :label="'****' + foundContract['contact1'].slice(-5)"
                          :color="insurer.color"
                        ></v-radio>
                        <v-radio
                          v-if="!!foundContract.contact2"
                          value="contact2"
                          :label="foundContract.contact2"
                          :color="insurer.color"
                        ></v-radio>
                      </v-radio-group>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn :color="insurer.color" dark>Continuar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <div
              v-else-if="found && rightInsured"
              style="max-width: 400px"
              class="mx-auto"
            >
              <v-row dense>
                <v-col>
                  <v-card outlined :disabled="loading">
                    <v-card-title>
                      Validação de código de segurança
                    </v-card-title>

                    <v-card-text>
                      <div>
                        Enviámos um código de 6 dígitos por SMS para o número
                        terminado em ***
                        {{ foundContract[selectedContact].slice(-5) }}.
                      </div>

                      <v-row class="my-6">
                        <v-col>
                          <v-otp-input
                            v-model="validationCode"
                            length="6"
                            :color="insurer.color"
                            dense
                            autofocus
                          ></v-otp-input>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn @click="selectedContact = null" text
                        >Escolher outro contacto</v-btn
                      >
                      <v-btn
                        :color="insurer.color"
                        :dark="otpValidated"
                        :disabled="!otpValidated"
                        :loading="loading"
                      >
                        Validar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-main>
      </v-app>
    </template>
  </InsurerPage>
</template>

<script>
import InsurerPage from "@/components/insurers/InsurerPage";
import InsurerLogo from "@/components/insurers/InsurerLogo.vue";

export default {
  mixins: [],

  components: { InsurerPage, InsurerLogo },

  props: {},

  data() {
    return {
      loading: false,

      nif: "",
      policyNumber: "",

      notFound: false,

      found: false,
      userName: "",

      rightInsured: false,

      validationCode: "",

      contracts: [
        {
          name: "António Sousa Santos",
          nif: "202484670",
          contact1: "2227089719",
          contact2: "",
          email: "antoniosousasantos@dayrep.com",
          contracts: [
            {
              policyNumber: "MR78110588",
              type: "Patrimonial",
              address: {
                id: 61,
                contact_id: 111,
                postal_code: "1070-250",
                country_area_id: 11,
                city_id: 153,
                city_area_id: null,
                street: "Rua Sampaio Pina",
                number: "70",
                is_default: true,
                local: "R/C",
                parent_id: null,
                country_id: 181,
                country_area: {
                  id: 11,
                  name: "Lisboa",
                },
                city: {
                  id: 153,
                  country_area_id: 11,
                  reference: "1106",
                  latitude: "38.716670",
                  longitude: "-9.133330",
                  name: "Lisboa",
                  translations: [
                    {
                      id: 153,
                      city_id: 153,
                      name: "Lisboa",
                      locale: "pt_BR",
                    },
                  ],
                },
                city_area: {
                  id: 2047,
                  name: "Lisboa",
                },
              },
            },
            {
              policyNumber: "MR78110589",
              type: "Patrimonial",
              address: {
                id: 61,
                contact_id: 111,
                postal_code: "1070-250",
                country_area_id: 11,
                city_id: 153,
                city_area_id: null,
                street: "Rua Sampaio Pina",
                number: "71",
                is_default: false,
                local: "R/C",
                parent_id: null,
                country_id: 181,
                country_area: {
                  id: 11,
                  name: "Lisboa",
                },
                city: {
                  id: 153,
                  country_area_id: 11,
                  reference: "1106",
                  latitude: "38.716670",
                  longitude: "-9.133330",
                  name: "Lisboa",
                  translations: [
                    {
                      id: 153,
                      city_id: 153,
                      name: "Lisboa",
                      locale: "pt_BR",
                    },
                  ],
                },
                city_area: {
                  id: 2047,
                  name: "Lisboa",
                },
              },
            },
          ],
          participants: [
            {
              id: "b1f5d9a2-7c4e-4a6d-9f1e-2c6f3a8d71b4",
              name: "António Sousa Santos",
              contact: {
                id: 111,
                contact1: "2227089719",
                contact2: "",
                email: "antoniosousasantos@dayrep.com",
                address: {
                  id: 61,
                  contact_id: 111,
                  postal_code: "1070-250",
                  country_area_id: 11,
                  city_id: 153,
                  city_area_id: null,
                  street: "Rua Sampaio Pina",
                  number: "70",
                  is_default: true,
                  local: "R/C",
                  parent_id: null,
                  country_id: 181,
                  country_area: {
                    id: 11,
                    name: "Lisboa",
                  },
                  city: {
                    id: 153,
                    country_area_id: 11,
                    reference: "1106",
                    latitude: "38.716670",
                    longitude: "-9.133330",
                    name: "Lisboa",
                    translations: [
                      {
                        id: 153,
                        city_id: 153,
                        name: "Lisboa",
                        locale: "pt_BR",
                      },
                    ],
                  },
                  city_area: {
                    id: 2047,
                    name: "Lisboa",
                  },
                },
              },
              participant_type: {
                id: 1,
                canonical: "insured",
                description: "Segurado",
              },
            },
          ],
        },
        {
          name: "Nicolas Ferreira Martins",
          nif: "201314096",
          contact1: "2436955076",
          contact2: "",
          email: "nicolasferreiramartins@dayrep.com",
          contracts: [
            {
              policyNumber: "MR78110590",
              type: "Patrimonial",
              address: {
                id: 61,
                contact_id: 111,
                postal_code: "2410132",
                country_area_id: 11,
                city_id: 153,
                city_area_id: null,
                street: "Rua MIGUEL TORGA LT 1 280 1 ESQ G LEIRIA",
                number: "280",
                is_default: true,
                local: "R/C",
                parent_id: null,
                country_id: 181,
                country_area: {
                  id: 10,
                  name: "Leiria",
                },
                city: {
                  id: 140,
                  country_area_id: 10,
                  reference: "1009",
                  latitude: "39.743620",
                  longitude: "-8.807050",
                  name: "Leiria",
                  translations: [
                    {
                      id: 140,
                      city_id: 140,
                      name: "Leiria",
                      locale: "pt_BR",
                    },
                  ],
                },
                city_area: {
                  id: 1936,
                  name: "Leiria",
                },
              },
            },
            {
              policyNumber: "MR78110490",
              type: "Patrimonial",
              address: {
                id: 61,
                contact_id: 111,
                postal_code: "2410132",
                country_area_id: 11,
                city_id: 153,
                city_area_id: null,
                street: "Rua MIGUEL TORGA LT 1 290 1 ESQ G LEIRIA",
                number: "290",
                is_default: false,
                local: "R/C",
                parent_id: null,
                country_id: 181,
                country_area: {
                  id: 10,
                  name: "Leiria",
                },
                city: {
                  id: 140,
                  country_area_id: 10,
                  reference: "1009",
                  latitude: "39.743620",
                  longitude: "-8.807050",
                  name: "Leiria",
                  translations: [
                    {
                      id: 140,
                      city_id: 140,
                      name: "Leiria",
                      locale: "pt_BR",
                    },
                  ],
                },
                city_area: {
                  id: 1936,
                  name: "Leiria",
                },
              },
            },
          ],
          // participants: [
          //   {
          //     id: "e3a9c6f4-1d72-4b8e-9a5c-0f2b7d8c4e61",
          //     name: "Nicolas Ferreira Martins",
          //     contact: {
          //       id: 111,
          //       contact1: "2436955076",
          //       contact2: "",
          //       email: "nicolasferreiramartins@dayrep.com",
          //       address: {
          //         id: 61,
          //         contact_id: 111,
          //         postal_code: "2410132",
          //         country_area_id: 11,
          //         city_id: 153,
          //         city_area_id: null,
          //         street: "Rua MIGUEL TORGA LT 1 280 1 ESQ G LEIRIA",
          //         number: "280",
          //         is_default: true,
          //         local: "AAA",
          //         parent_id: null,
          //         country_id: 181,
          //         country_area: {
          //           id: 10,
          //           name: "Leiria",
          //         },
          //         city: {
          //           id: 140,
          //           country_area_id: 10,
          //           reference: "1009",
          //           latitude: "39.743620",
          //           longitude: "-8.807050",
          //           name: "Leiria",
          //           translations: [
          //             {
          //               id: 140,
          //               city_id: 140,
          //               name: "Leiria",
          //               locale: "pt_BR",
          //             },
          //           ],
          //         },
          //         city_area: {
          //           id: 1936,
          //           name: "Leiria",
          //         },
          //       },
          //     },
          //     participant_type: {
          //       id: 1,
          //       canonical: "insured",
          //       description: "Segurado",
          //     },
          //   },
          // ],
        },
        {
          name: "Vitór Araujo Cavalcanti",
          nif: "284600083",
          contact1: "2347568295",
          contact2: "",
          email: "vitoraraujocavalcanti@teleworm.us",
          contracts: [
            {
              policyNumber: "MR78110591",
              type: "Patrimonial",
              address: {
                id: 61,
                contact_id: 111,
                postal_code: "1000123",
                country_area_id: 11,
                city_id: 153,
                city_area_id: null,
                street: "AV JOAO XXI 9 A TESTE CSS VIA SCRUBBING-LISBO",
                number: "780",
                is_default: true,
                local: "AAA",
                parent_id: null,
                country_id: 181,
                country_area: {
                  id: 11,
                  name: "Lisboa",
                },
                city: {
                  id: 153,
                  country_area_id: 11,
                  reference: "1106",
                  latitude: "38.716670",
                  longitude: "-9.133330",
                  name: "Lisboa",
                  translations: [
                    {
                      id: 153,
                      city_id: 153,
                      name: "Lisboa",
                      locale: "pt_BR",
                    },
                  ],
                },
                city_area: {
                  id: 2047,
                  name: "Lisboa",
                },
              },
            },
            {
              policyNumber: "MR78110491",
              type: "Patrimonial",
              address: {
                id: 61,
                contact_id: 111,
                postal_code: "1000123",
                country_area_id: 11,
                city_id: 153,
                city_area_id: null,
                street: "AV JOAO XXI 9 A TESTE CSS VIA SCRUBBING-LISBO",
                number: "781",
                is_default: false,
                local: "AAA",
                parent_id: null,
                country_id: 181,
                country_area: {
                  id: 11,
                  name: "Lisboa",
                },
                city: {
                  id: 153,
                  country_area_id: 11,
                  reference: "1106",
                  latitude: "38.716670",
                  longitude: "-9.133330",
                  name: "Lisboa",
                  translations: [
                    {
                      id: 153,
                      city_id: 153,
                      name: "Lisboa",
                      locale: "pt_BR",
                    },
                  ],
                },
                city_area: {
                  id: 2047,
                  name: "Lisboa",
                },
              },
            },
          ],
          // participants: [
          //   {
          //     id: "e3a9c6f4-1d72-4b8e-9a5c-0f2b7d8c4e61",
          //     name: "Nicolas Ferreira Martins",
          //     contact: {
          //       id: 111,
          //       contact1: "2436955076",
          //       contact2: "",
          //       email: "nicolasferreiramartins@dayrep.com",
          //       address: {
          //         id: 61,
          //         contact_id: 111,
          //         postal_code: "2410132",
          //         country_area_id: 11,
          //         city_id: 153,
          //         city_area_id: null,
          //         street: "Rua MIGUEL TORGA LT 1 280 1 ESQ G LEIRIA",
          //         number: "280",
          //         is_default: true,
          //         local: "AAA",
          //         parent_id: null,
          //         country_id: 181,
          //         country_area: {
          //           id: 10,
          //           name: "Leiria",
          //         },
          //         city: {
          //           id: 140,
          //           country_area_id: 10,
          //           reference: "1009",
          //           latitude: "39.743620",
          //           longitude: "-8.807050",
          //           name: "Leiria",
          //           translations: [
          //             {
          //               id: 140,
          //               city_id: 140,
          //               name: "Leiria",
          //               locale: "pt_BR",
          //             },
          //           ],
          //         },
          //         city_area: {
          //           id: 1936,
          //           name: "Leiria",
          //         },
          //       },
          //     },
          //     participant_type: {
          //       id: 1,
          //       canonical: "insured",
          //       description: "Segurado",
          //     },
          //   },
          // ],
        },
        {
          name: "Rui Mariano",
          nif: "201909952",
          contact1: "933803724",
          contact2: "",
          email: "rui_mariano@hotmail.com",
          contracts: [
            {
              policyNumber: "MR78110291",
              type: "Patrimonial",
              address: {
                id: 61,
                contact_id: 111,
                postal_code: "2744002",
                country_area_id: 11,
                city_id: 153,
                city_area_id: null,
                street: "TAGUSPARK EDF 4 1 A  MILLENNIUM BCP QC Q-PORT",
                number: "41",
                is_default: true,
                local: "AAA",
                parent_id: null,
                country_id: 181,
                country_area: {
                  id: 11,
                  name: "Lisboa",
                },
                city: {
                  id: 157,
                  country_area_id: 11,
                  reference: "1110",
                  latitude: "38.691050",
                  longitude: "-9.310850",
                  name: "Oeiras",
                  translations: [
                    {
                      id: 157,
                      city_id: 157,
                      name: "Oeiras",
                      locale: "pt_BR",
                    },
                  ],
                },
                city_area: {
                  id: 2096,
                  name: "Porto Salvo",
                },
              },
            },
            {
              policyNumber: "MR78110191",
              type: "Patrimonial",
              address: {
                id: 61,
                contact_id: 111,
                postal_code: "2744002",
                country_area_id: 11,
                city_id: 153,
                city_area_id: null,
                street: "TAGUSPARK EDF 4 1 A  MILLENNIUM BCP QC Q-PORT",
                number: "44",
                is_default: false,
                local: "AAA",
                parent_id: null,
                country_id: 181,
                country_area: {
                  id: 11,
                  name: "Lisboa",
                },
                city: {
                  id: 157,
                  country_area_id: 11,
                  reference: "1110",
                  latitude: "38.691050",
                  longitude: "-9.310850",
                  name: "Oeiras",
                  translations: [
                    {
                      id: 157,
                      city_id: 157,
                      name: "Oeiras",
                      locale: "pt_BR",
                    },
                  ],
                },
                city_area: {
                  id: 2096,
                  name: "Porto Salvo",
                },
              },
            },
          ],
          // participants: [
          //   {
          //     id: "f7c3d2e4-5b6a-4c8d-9e2f-3a4b5c6d7e8f",
          //     name: "Rui Mariano",
          //     contact: {
          //       id: 111,
          //       contact1: "933803724",
          //       contact2: "",
          //       email: "rui_mariano@hotmail.com",
          //       address: {
          //         id: 61,
          //         contact_id: 111,
          //         postal_code: "2744002",
          //         country_area_id: 11,
          //         city_id: 153,
          //         city_area_id: null,
          //         street: "TAGUSPARK EDF 4 1 A  MILLENNIUM BCP QC Q-PORT",
          //         number: "41",
          //         is_default: true,
          //         local: "AAA",
          //         parent_id: null,
          //         country_id: 181,
          //         country_area: {
          //           id: 11,
          //           name: "Lisboa",
          //         },
          //         city: {
          //           id: 157,
          //           country_area_id: 11,
          //           reference: "1110",
          //           latitude: "38.691050",
          //           longitude: "-9.310850",
          //           name: "Oeiras",
          //           translations: [
          //             {
          //               id: 157,
          //               city_id: 157,
          //               name: "Oeiras",
          //               locale: "pt_BR",
          //             },
          //           ],
          //         },
          //         city_area: {
          //           id: 2096,
          //           name: "Porto Salvo",
          //         },
          //       },
          //     },
          //     participant_type: {
          //       id: 1,
          //       canonical: "insured",
          //       description: "Segurado",
          //     },
          //   },
          // ],
        },
      ],

      foundContract: null,

      selectedContact: null,
    };
  },

  methods: {
    async search() {
      this.loading = true;
      this.notFound = false;

      setTimeout(() => {
        this.loading = false;

        if (this.policyNumber) {
          this.findByPolicyNumber();
          this.found = true;
          return;
        }

        if (this.nif) {
          this.findByNif();
          this.found = true;
          return;
        }
      }, 1000);
    },

    saveInsured() {
      const payload = JSON.stringify(this.foundContract);

      localStorage.setItem("insured", payload);
    },

    saveParticipants() {
      if (!this.foundContract?.participants) {
        localStorage.setItem("participants", JSON.stringify([]));
        return;
      }

      localStorage.setItem(
        "participants",
        JSON.stringify(this.foundContract.participants)
      );
    },

    findByPolicyNumber() {
      this.contracts.forEach((person) => {
        person.contracts.forEach((contract) => {
          if (contract.policyNumber === this.policyNumber) {
            this.foundContract = {
              ...person,
              contracts: person.contracts.filter(
                (c) => this.policyNumber === c.policyNumber
              ),
            };
          }
        });
      });
    },

    findByNif() {
      const nif = this.nif.replaceAll(" ", "");
      this.contracts.forEach((person) => {
        if (person.nif === nif) {
          this.foundContract = { ...person };
        }
      });
    },

    handleClickWrongInsured() {
      this.found = false;
      this.nif = "";
      this.policyNumber = "";
      this.foundContract = null;
    },

    handleClickRightInsured(contract) {
      this.rightInsured = true;
      this.foundContract = {
        ...this.foundContract,
        contracts: this.foundContract.contracts.filter(
          (i) => i.policyNumber === contract.policyNumber
        ),
      };
      this.saveInsured();
      this.saveParticipants();
    },

    handleOptInputed() {
      this.loading = true;

      setTimeout(() => {
        this.loading = false;

        this.$router.push({ name: "customers-inbound-update" });
      }, 1500);
    },

    formatAddress(address) {
      if (!address) return "Endereço não disponível";

      return [
        address.street,
        address.number && `Nº ${address.number}`,
        address.city?.name,
        address.country_area?.name,
        address.postal_code,
      ]
        .filter(Boolean)
        .join(", ");
    },
  },

  computed: {
    validated() {
      if (!this.nif && !this.policyNumber) {
        return false;
      }

      if (!!this.nif && this.nif.length < 11) {
        return false;
      }

      return true;
    },

    otpValidated() {
      if (this.validationCode.length < 6) {
        return false;
      }

      return true;
    },

    contractsToDisplay() {
      if (!this.foundContract?.contracts) return [];

      return this.foundContract.contracts.map((contract) => ({
        policyNumber: contract.policyNumber,
        type: contract.type,
        address: contract.address || null,
      }));
    },
  },

  watch: {
    validationCode(value) {
      if (value.length < 6) {
        return;
      }

      this.handleOptInputed();
    },
  },
};
</script>
